<template>
    <button
        aria-label="Перейти в начало страницы"
        :class="
            scrollOverScreen
                ? 'bottom-28 scale-100 opacity-50 hover:opacity-100'
                : 'bottom-0 scale-0 opacity-0'
        "
        class="fixed right-5 z-40 rounded-8 bg-accent/50 px-3 pb-5 pt-4 transition-all duration-300 md:right-10"
        @click="scrollToTop">
        <svg
            viewBox="0 0 38 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="38"
            height="24">
            <g opacity="0.5">
                <g filter="url(#filter0_i_4584_962)">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.96655 22.0017C0.677817 20.6706 0.677817 18.5125 1.96655 17.1814L16.6665 1.99831C17.9553 0.667228 20.0447 0.667228 21.3335 1.99831L36.0335 17.1814C37.3222 18.5125 37.3222 20.6706 36.0335 22.0017C34.7447 23.3328 32.6553 23.3328 31.3665 22.0017L19 9.22873L6.63345 22.0017C5.34472 23.3328 3.25528 23.3328 1.96655 22.0017Z"
                        fill="url(#paint0_linear_4584_962)" />
                </g>
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.96655 22.0017C0.677817 20.6706 0.677817 18.5125 1.96655 17.1814L16.6665 1.99831C17.9553 0.667228 20.0447 0.667228 21.3335 1.99831L36.0335 17.1814C37.3222 18.5125 37.3222 20.6706 36.0335 22.0017C34.7447 23.3328 32.6553 23.3328 31.3665 22.0017L19 9.22873L6.63345 22.0017C5.34472 23.3328 3.25528 23.3328 1.96655 22.0017Z"
                    stroke="white"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </g>
            <defs>
                <filter
                    id="filter0_i_4584_962"
                    x="0.5"
                    y="0.5"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                    width="37"
                    height="23">
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="9" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_4584_962" />
                </filter>
                <linearGradient
                    id="paint0_linear_4584_962"
                    x1="1"
                    y1="12"
                    x2="37"
                    y2="12"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" />
                    <stop
                        offset="1"
                        stop-color="white"
                        stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    </button>
</template>

<script setup lang="ts">
const scrollOverScreen = ref<boolean>(false)

function scrollToTop() {
    document.body.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    })
}

onMounted(() => {
    if (window) {
        scrollOverScreen.value = window.scrollY > window.innerHeight
    }

    window.addEventListener('scroll', () => {
        scrollOverScreen.value = window.scrollY > window.innerHeight
    })
})
</script>
